module.exports = __webpack_public_path__ + "static/media/icon_qualitygoals_grey.7b101a46.svg";